import stylesheet0 from "@oneappexchange/appx-font-utilities";
import stylesheet1 from "@oneappexchange/appx-grid";

function stylesheet(token, useActualHostSelector, useNativeDirPseudoclass) {
  var shadowSelector = token ? ("[" + token + "]") : "";
  var hostSelector = token ? ("[" + token + "-host]") : "";
  var suffixToken = token ? ("-" + token) : "";
  return ".divider" + shadowSelector + " {border: 1px solid #ecebea;margin: var(--sds-g-spacing-10) 0px;}[grid]" + shadowSelector + ",[grid]" + shadowSelector + " *" + shadowSelector + ",[grid]" + shadowSelector + " *" + shadowSelector + ":before,[grid]" + shadowSelector + " *" + shadowSelector + ":after {box-sizing: border-box;}";
  /*LWC compiler v7.1.3*/
}
export default [stylesheet0, stylesheet1, stylesheet];